<div class="container-fluid">
  <div class="container-fluid mt-3 mb-5 py-5 container-shadow">
    <div *ngIf="loading" class="text-center">
      <i class="fas fa-spinner fa-pulse fa-fw fa-5x"></i>
    </div>
    <div *ngIf="!loading">
      <h3 *ngIf="tax.id">
        {{ tax.name }}
        &nbsp;
        <small>
          <a [routerLink]="'/taxes/' + tax.id + '/edit'"><i class="fas fa-edit"></i></a>
          &nbsp;
          <a href="#" (click)="delete(); $event.preventDefault()" class="text-danger"><i class="fas fa-trash-alt"></i></a>
        </small>
      </h3>
      <div class="row">
        <div class="col-sm-8 col-md-6">
          <table class="table">
            <tbody>
              <tr>
                <th scope="row">Type</th>
                <td>{{ tax.type_str }}</td>
              </tr>
              <tr>
                <th scope="row">Chart of Account</th>
                <td>
                  <a [href]="'/chart_of_accounts/' + tax.chart_of_account_id">{{ tax.chart_of_account_name }}</a>
                </td>
              </tr>
              <tr>
                <th scope="row">Pay To</th>
                <td>
                  <a [href]="'/contacts/' + tax.contact_id">{{ tax.contact_name }}</a>
                </td>
              </tr>
              <tr>
                <th scope="row">Amount:</th>
                <td>
                  <span *ngIf="tax.way == 'percent'">{{ tax.amount }}{{ tax.amount ? '%' : '' }}</span>
                  <span *ngIf="tax.way == 'amount'">{{ tax.amount | currency: 'USD':'symbol-narrow':'1.2-2' }}</span>
                  <span *ngIf="tax.way != 'percent' && tax.way != 'amount'">variable</span>
                </td>
              </tr>
              <tr>
                <th scope="row">Cutoff</th>
                <td>{{ tax.cutoff | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
              </tr>
              <tr>
                <th scope="row">Above</th>
                <td>{{ tax.above || 0.0 | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
              </tr>
              <tr>
                <th scope="row">Frequency</th>
                <td>{{ tax.frequency }}</td>
              </tr>
              <tr>
                <th scope="row">Way</th>
                <td>{{ tax.way }}</td>
              </tr>
              <tr>
                <th scope="row">Auto Pay</th>
                <td>{{ tax.is_auto_pay ? 'Yes' : 'No' }}</td>
              </tr>
              <tr>
                <th scope="row">Outstanding Obligation</th>
                <td>{{ tax.outstanding_obligation | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <h4>Entry Groups</h4>
          <table class="table">
            <thead class="thead-light">
              <tr>
                <th>Id</th>
                <th>Type</th>
                <th>Description</th>
                <th>Date</th>
                <th>Obligation</th>
                <th>Amount Paid</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let entryGroup of tax.entry_groups">
                <td>
                  <a [href]="'/entry_groups/' + entryGroup.id">{{ entryGroup.id }}</a>
                </td>
                <td>
                  <a [href]="entryGroup.entry_groups_url">{{ entryGroup.entry_group_type_name }}</a>
                </td>
                <td>{{ entryGroup.description }}</td>
                <td>{{ entryGroup.created_at }}</td>
                <td>{{ entryGroup.obligations | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
                <td>{{ entryGroup.amount_paid | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
